"use client";

// Закрытие поповера по клику мимо — ЕДИНСТВЕННАЯ реализация (раньше этот
// useEffect с mousedown был скопирован ~17 раз по компонентам).
//
// target:
//  • ref (или массив ref'ов) — закрыть, когда клик вне всех смонтированных
//    узлов; если ни один не смонтирован — не закрываем (поведение старых копий
//    с guard'ом `ref.current && …`);
//  • CSS-селектор — закрыть, когда у цели клика нет предка по селектору
//    (паттерн `[data-…]`-меню, где содержимое рендерится порталом).

import { useEffect, useRef, type RefObject } from "react";

type Target = RefObject<HTMLElement | null> | Array<RefObject<HTMLElement | null>> | string;

export function useOutsideClick(target: Target, onOutside: () => void, enabled: boolean = true) {
  const cbRef = useRef(onOutside);
  cbRef.current = onOutside;
  const targetRef = useRef(target);
  targetRef.current = target;

  useEffect(() => {
    if (!enabled) return;
    const handle = (e: MouseEvent) => {
      const t = targetRef.current;
      const node = e.target as Node;
      if (typeof t === "string") {
        if (!(node instanceof HTMLElement ? node : node.parentElement)?.closest(t)) cbRef.current();
        return;
      }
      const refs = Array.isArray(t) ? t : [t];
      const mounted = refs.map((r) => r.current).filter((el): el is HTMLElement => !!el);
      if (mounted.length > 0 && mounted.every((el) => !el.contains(node))) cbRef.current();
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, [enabled]);
}
